import { Link } from 'react-router-dom';
import { featuredTracks } from '@/mocks/asmr';

const trackImages: string[] = [
  'https://readdy.ai/api/search-image?query=Calm%20bedroom%20at%20night%20with%20soft%20warm%20amber%20lighting%2C%20gentle%20whisper%20aesthetic%2C%20cozy%20bedding%20in%20cream%20tones%2C%20peaceful%20sleep%20atmosphere%2C%20minimalist%20interior%2C%20dreamy%20soft%20focus%20photography&width=800&height=500&seq=track-01-img&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Rainy%20window%20at%20night%20with%20water%20droplets%2C%20warm%20indoor%20light%2C%20cozy%20atmosphere%2C%20soft%20diffused%20glow%2C%20peaceful%20rainy%20evening%20mood%2C%20minimalist%20interior%2C%20dreamy%20soft%20focus%20photography&width=800&height=500&seq=track-02-img&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Quiet%20library%20reading%20room%20with%20warm%20wooden%20furniture%2C%20soft%20natural%20light%2C%20bookshelves%2C%20peaceful%20study%20atmosphere%2C%20minimalist%20academic%20interior%2C%20cream%20and%20beige%20tones%2C%20editorial%20photography&width=800&height=500&seq=track-03-img&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Deep%20ocean%20underwater%20scene%20with%20soft%20blue%20light%20rays%2C%20gentle%20whale%20silhouette%2C%20peaceful%20aquatic%20atmosphere%2C%20serene%20deep%20sea%20mood%2C%20minimalist%20underwater%20photography%2C%20dreamy%20soft%20focus&width=800&height=500&seq=track-04-img&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Soft%20abstract%20noise%20texture%20with%20warm%20pink%20and%20cream%20gradients%2C%20gentle%20waves%20pattern%2C%20calming%20visual%20aesthetic%2C%20minimalist%20abstract%20art%2C%20soothing%20color%20palette%2C%20dreamy%20soft%20focus%20photography&width=800&height=500&seq=track-05-img&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Soft%20hair%20brushing%20aesthetic%20with%20warm%20lighting%2C%20gentle%20textures%2C%20cozy%20salon%20atmosphere%2C%20peaceful%20self%20care%20mood%2C%20cream%20and%20beige%20tones%2C%20minimalist%20interior%2C%20dreamy%20soft%20focus%20photography&width=800&height=500&seq=track-06-img&orientation=landscape',
];

export default function FeaturedSection() {
  return (
    <section className="py-16 md:py-20 px-4 md:px-6 lg:px-8 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col sm:flex-row items-start sm:items-end justify-between mb-10 gap-4">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-2">
              热门推荐
            </h2>
            <p className="text-foreground-500 text-sm">最受欢迎的ASMR音频，大家都在听</p>
          </div>
          <Link
            to="/category/zhumian"
            className="text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors whitespace-nowrap flex items-center gap-1"
          >
            查看全部 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {featuredTracks.map((track, idx) => (
            <div
              key={track.id}
              className="group bg-background-50 rounded-2xl overflow-hidden transition-all duration-300 hover:bg-background-200/50 cursor-pointer"
            >
              <div className="aspect-[16/10] overflow-hidden relative">
                <img
                  src={trackImages[idx]}
                  alt={track.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent"></div>
                <div className="absolute bottom-3 left-3 right-3">
                  <span className="inline-block px-2.5 py-1 bg-background-50/90 backdrop-blur-sm text-foreground-800 text-xs rounded-full font-medium">
                    {track.categoryName}
                  </span>
                </div>
                <div className="absolute top-3 right-3 w-10 h-10 rounded-full bg-primary-500/90 backdrop-blur-sm flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <i className="ri-play-fill text-background-50 text-lg"></i>
                </div>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-900 mb-1 group-hover:text-primary-600 transition-colors">
                  {track.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed mb-3 line-clamp-2">
                  {track.description}
                </p>
                <div className="flex items-center gap-4 text-xs text-foreground-400">
                  <span className="flex items-center gap-1">
                    <i className="ri-time-line"></i> {track.duration}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-headphone-line"></i> {(track.listens / 10000).toFixed(1)}万次
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}